import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import {specify} from '@/validator'

import {getModule,getAttachment} from './model'

import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)


const state = {
  staff:null,
  category:[],
  Allstaffs:[],
  Refreshment:[], 
  Ticket:[],
  Movie:[],
  Campus:[],
  lMovies:[],
  Watch:[]

  }
  //initialize mutations
  const mutations = {
  changeStaff(state, data) {
  state.staff = data
  },
  updateStaffAfterCorres(state,camp){
    state.staff.campus = camp;
  },
 updateCategory(state, data) {
   state.category = data
 },
 updateStaffs(state, data) {
    state.Allstaffs = data
 },
  updateRefreshment(state, data) {
    state.Refreshment = data
  },
  updateTicket(state, data) {
    state.Ticket = data
  },
  updateMovie(state, data) {
    state.Movie = data
  },
  updateCampus(state, data) {
    state.Campus = data
  },
  updateLinkedMovies(state, data) {
    state.lMovies = data
  },
  updateWatch(state, data) {
    state.Watch = data
  }


  }
let check =0;let temp =[];
let movCheck =0;let movTemp =[];
let camCheck =0;let camTemp =[];
let watCheck =0;let watTemp =[];
  const actions = {
    updateCategory(context,action){
     
      getModule('category',function(response){
  if(response.status == 200){
    if(response.data[0] == null){
      
      context.commit('updateCategory',response.data);
      return;
    }
    
    let value = response.data;
    for(let i=0;i<value.length;i++){
      getAttachment('category',value[i].name,function(response){
        if(action == true){ check = 0;}
        if(check== 0){
          value[i].image = response;
          temp[value[i].name] =response;
            
        }else{
          value[i].image =  temp[value[i].name];
        }
        
        if((i+1) == value.length){
           if(check==0){
          context.commit('updateCategory',value);
          check++;
          }
   }
      });
     
          }
            
      
  }else{
      console.log("Unknown Error!!!");
      }
  
  
  
  });

    },

    updateStaffs(context){
      
       getModule('staff',function(response){
   if(response.status == 200){
     if(response.data[0] == null){
       
       context.commit('updateStaffs',response.data);
       return;
     }
     
     let value = response.data;
     for(let i=0;i<value.length;i++){
               
           value[i].sn = (i+1);
           
         if((i+1) == value.length){
            
           context.commit('updateStaffs',value);
           
    }
      
      
           }
             
       
   }else{
       console.log("Unknown Error!!!");
       }
   
   
   
   });
 
     },
     updateRefreshments(context){
      
       getModule('refreshment',function(response){
   if(response.status == 200){
     if(response.data[0] == null){
       context.commit('updateRefreshment',response.data);
       return;
     }
     
     let value = response.data;
     for(let i=0;i<value.length;i++){
               
           value[i].sn = (i+1);
           
         if((i+1) == value.length){
            
           context.commit('updateRefreshment',value);
           
    }
      
      
           }
             
       
   }else{
       console.log("Unknown Error!!!");
       }
   
   
   
   });
 
     },
     updateTickets(context){
      
       getModule('ticket',function(response){
   if(response.status == 200){
     if(response.data[0] == null){
       context.commit('updateTicket',response.data);
       return;
     }    
     
     let value = response.data;
     for(let i=0;i<value.length;i++){
               
           value[i].sn = (i+1);
           
         if((i+1) == value.length){
            
           context.commit('updateTicket',value);
           
    }
      
      
           }
             
       
   }else{
       console.log("Unknown Error!!!");
       }
   
   
   
   });
 
     },
     updateMovies(context,action){
      
       getModule('movie',function(response){
   if(response.status == 200){
     if(response.data[0] == null){
       
       context.commit('updateMovie',response.data);
       return;
     }
     
     let value = response.data;
     for(let i=0;i<value.length;i++){
       getAttachment('movie',value[i].name,function(response){
         if(action == true){ movCheck = 0;}
         if(movCheck== 0){
           value[i].image = response;
           movTemp[value[i].name] =response;
           value[i].sn = (i+1);
             
         }else{
           value[i].image =  movTemp[value[i].name];
         }
         
         if((i+1) == value.length){
            if(movCheck==0){
           context.commit('updateMovie',value);
           movCheck++;
           }
    }
       });
      
           }
             
       
   }else{
       console.log("Unknown Error!!!");
       }
   
   
   
   });
 
     },
     updateCampus(context,action){
      
       getModule('campus',function(response){
   if(response.status == 200){
     if(response.data[0] == null){
       
       context.commit('updateCampus',response.data);
       return;
     }
     
     let value = response.data;
     for(let i=0;i<value.length;i++){
       getAttachment('campus',value[i].name,function(response){
         if(action == true){ camCheck = 0;}
         if(camCheck== 0){
           value[i].image = response;
           camTemp[value[i].name] =response;
             
         }else{
           value[i].image =  camTemp[value[i].name];
         }
         
         if((i+1) == value.length){
            if(camCheck==0){
           context.commit('updateCampus',value);
           camCheck++;
           }
    }
       });
      
           }
             
       
   }else{
       console.log("Unknown Error!!!");
       }
   
   
   
   });
 
     },
     updateLinkedMovies(context,camp){
      
       getModule('campus',function(response){
   if(response.status == 200){
     if(response.data[0] == null){
       
       context.commit('updateLinkedMovies',response.data);
       return;
     }
     
     let value = response.data;
     let ret =  specify(value,'name',camp);
     value = ret[0].movies;
     
     for(let i=0;i<value.length;i++){
               
           value[i].sn = (i+1);
           
    }
    context.commit('updateLinkedMovies',value);
    
       
   }else{
       console.log("Unknown Error!!!");
       }
   
   
   
   });
 
     },
     updateWatch(context,action){
      
       getModule('watch',function(response){
   if(response.status == 200){
     if(response.data[0] == null){
       
       context.commit('updateWatch',response.data);
       return;
     }
     
     let value = response.data;
     for(let i=0;i<value.length;i++){
       getAttachment('watch',value[i].name,function(response){
         if(action == true){ watCheck = 0;}
         if(watCheck== 0){
           value[i].image = response;
           watTemp[value[i].name] =response;
           value[i].sn = (i+1);
             
         }else{
           value[i].image =  watTemp[value[i].name];
         }
         
         if((i+1) == value.length){
            if(watCheck==0){
           context.commit('updateWatch',value);
           watCheck++;
           }
    }
       });
      
           }
             
       
   }else{
       console.log("Unknown Error!!!");
       }
   
   
   
   });
 
     }
   
  }
  
export default new Vuex.Store({
  state,
  mutations,
  getters,
  plugins: [createPersistedState()],
  actions
})
